import axios from 'axios';
import { store } from 'store';
import { checkForNotification } from 'layout/nav/notifications/notificationSlice';

const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:8002';
const prefix = '/api/v1';

const $axios = axios.create({
  baseURL: `${baseURL}${prefix}`,
  timeout: 30000,
});

$axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('at');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

$axios.interceptors.response.use(
  (response) => {
    try {
      const token = localStorage.getItem('at');
      const isLoginPage = window.location.pathname.includes('/login');
      const isNotificationApi = response.config.url.includes('/notifications');

      if (token && !isLoginPage && !isNotificationApi) {
        store.dispatch(checkForNotification());
      }
    } catch (error) {
      console.error('Notification check failed:', error.message);
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      store.dispatch({ type: 'auth-slice/logout' });
      const isLoginPage = window.location.pathname.includes('/login');
      if (!isLoginPage) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default $axios;
